import {Component, OnDestroy, OnInit} from '@angular/core';
import {LevelService} from './shared/services/level/level.service';
import {StatesService} from './shared/services/state/states.service';
import {AuthenticationService} from './shared/services/authentication/authentication.service';
import {Subscription} from 'rxjs/index';
import {User} from './shared/classes/user/user';
import {TranslateService} from '@ngx-translate/core';
import {DateAdapter} from '@angular/material/core';
import {MatSelectChange} from '@angular/material/select';
import {Level} from './shared/classes/level/level';
import {Router} from '@angular/router';
import {IconService} from './shared/services/icon/icon.service';
import {environment} from '../environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  public levelsDropList: any[] = [];
  public reloadLevelSelector: Subscription;
  public user: User;
  public showSpinner: boolean;
  public date = new Date();
  public langSelected: string = 'en';

  constructor(private router: Router,
              private levelService: LevelService,
              public statesService: StatesService,
              public authenticationService: AuthenticationService,
              public iconService: IconService,
              private translate: TranslateService,
              private dateAdapter: DateAdapter<any>) {
  }

  ngOnInit() {
    const lang = this.authenticationService.getUserLang();
    this.translate.setDefaultLang(lang);
    this.dateAdapter.setLocale(lang);
    this.initListLevels();
    this.reloadLevelSelector = this.statesService.reloadLevelSelector.subscribe(() => {
      this.initListLevels();
      this.langSelected = this.authenticationService.getUserLang();
      this.translate.use(this.langSelected);
    });
  }

  ngOnDestroy() {
    this.reloadLevelSelector.unsubscribe();
  }

  initListLevels() {
    const currentUser = this.authenticationService.getStoredUser();
    if (currentUser) {
      this.showSpinner = true;
      this.levelService.getLevels(true).subscribe((data: any) => {
          this.levelsDropList = data.sort((a, b) => a.name.localeCompare(b.name));
          this.showSpinner = false;
          this.statesService.stateLevelSubject.next(this.getLevelFromId(this.statesService.stateLevel, this.levelsDropList));
        },
        () => this.statesService.stateLevelSubject.next(null));

    }
  }

  setLang(event: MatSelectChange) {
    let lang = event.value;
    this.statesService.stateLanguage = lang;
    this.translate.use(lang);
    this.dateAdapter.setLocale(lang);
    this.statesService.languageChanged.next();
  }

  selectLevel(event: MatSelectChange) {
    this.statesService.stateLevelSubject.next(this.getLevelFromId(event.value, this.levelsDropList));
    this.router.navigateByUrl('/projects');
  }

  userIsLogged(): boolean {
    return this.user = this.authenticationService.getStoredUser();
  }

  opmMode(): boolean {
    if (!environment.clientModeEnabled) {
      return true;
    }
    return this.authenticationService.userHasRoleOsmos();

  }

  getLang() {
    return this.translate.currentLang !== undefined ? this.translate.currentLang : 'en';
  }

  private getLevelFromId(levelId, levelsList) {
    return levelsList.find(
      (level: Level) => level.id === levelId
    );
  }

}
